import { PadBox } from 'component/basics';
import { Tag } from 'component/button';
import { colorTagVerified } from 'component/color';
import type { TopicConfig } from 'structure/topic';
import { StructureDemo } from 'util/instance';
import type { Feature } from 'util/stdtypes';
import { t } from 'util/stdtypes';

function TopicConfigDemoScreen(): JSX.Element {
    const globals = {
        name: 'Godzilla',
    };
    return (
        <StructureDemo
            features={{
                topic_config: true,
                topicrelatedcontent: false,
                topiclivestatus: false,
                topicpoll: false,
                nexttopicpoll: false,
                topicfollow: false,
                topicparticipants: false,
            }}
            structureKey='topic'
            testState={{ globals }}
            // features={{topic_config: true, topicrelatedcontent: false}}
        />
    );
}

export const TopicConfigFeature: Feature<TopicConfig, {}> = {
    name: 'Show Topic Config Slots',
    key: 'topic_config',
    dev: true,
    providesConfig: {
        topicContentWidgets: [() => <DemoWidget text='Topic Content Widget' />],
        topicTopWidgets: [() => <DemoWidget text='Topic Top Widget' />],
        topicBottomWidgets: [() => <DemoWidget text='Topic Bottom Widget' />],
        topicHeaderLeftWidgets: [() => <MiniWidget text='Topic Header Left Widget' />],
        topicHeaderRightWidgets: [() => <MiniWidget text='Topic Header Right Widget' />],
        topicHeaderBottomWidgets: [() => <MiniWidget text='Topic Header Bottom Widget' />],
    },
};

export type DemoWidgetProps = { color?: string; text: string };

export function DemoWidget({ color = colorTagVerified, text }: DemoWidgetProps): JSX.Element {
    return (
        <PadBox bottom={10}>
            <Tag color={color} text={text} />
        </PadBox>
    );
}

export type MiniWidgetProps = { text: string; color?: string };

export function MiniWidget({ text, color = colorTagVerified }: MiniWidgetProps): JSX.Element {
    return <Tag color={color} compact text={text} />;
}
